import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useAuth } from "../auth/AuthProvider";
import EmailVerifyBanner from "./EmailVerifyBanner";

export default function RootLayout() {
    
  // const { user } = useAuth();

  return (
    <>
    <div className="app-wrapper">
      <main>
      <Header />     {/* ✅ อยู่คงที่ทุกหน้า */}
      </main>

      {/* {user && <EmailVerifyBanner />} */}
      <main className="app-main"><Outlet /></main>  {/* ✅ เนื้อหาเปลี่ยนตาม route */}

      <footer className="app-footer">
      <Footer />
      </footer>

      </div>
    </>
    
  );
}